import React from 'react';
import './admin-game-buttons.styles.scss';
import ga4 from 'react-ga4';
import { useNavigate } from 'react-router-dom';

const AdminGameViewButtons = ({
    view,
    setView
}) => {

    const navigate = useNavigate();

    return (
        <div className='admin-game-view-button-row'>
            <button 
                className={`g-button small-btn ${view === 'gameData' ? 'primary' : ''}`}
                onClick={() => view !== 'gameData' ? setView('gameData') : null}>
                Game Data
            </button>
            <button 
                className={`g-button small-btn ${view === 'players' ? 'primary' : ''}`}
                onClick={() => view !== 'players' ? setView('players') : null}>
                View Players
            </button>
            <button 
                className={`g-button small-btn ${view === 'elements' ? 'primary' : ''}`}
                onClick={() => view !== 'elements' ? setView('elements') : null}>
                View Game Elements
            </button>
            <button 
                className={`g-button small-btn ${view === 'download' ? 'primary' : ''}`}
                onClick={() => view !== 'download' ? setView('download') : null}>
                Download
            </button>
        </div>
    )
}

export default AdminGameViewButtons